import { Col, Row, Select, Spin, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./UtilizationDashboardPage.css";

import { UpdateAppConfig } from "../../../src/services/redux/reducers/app";

import {
  GetStatus,
  GetCustomerCurrentTime,
  GetCurrentShiftIndex,
  GetUtilizationData,
  pad,
  readOperatorList,
} from "../../../src/services/common/cnc_apis";
import { CSSTransition } from "react-transition-group";
import UtilizationDetailPage from "./UtilizationDetailPage/UtilizationDetailPage";
import MachineItemContainer from "./MainPage/MachineItemContainer";

const { Option } = Select;

function UtilizationDashboardPage(props) {
  const location = useLocation();
  const appData = useSelector((state) => state.app);
  const authData = useSelector((x) => x.authService);
  const { security_level } = authData;
  const { langIndex } = appData;
  const { screenSize } = props.app;

  const customer_id = props.app.customer_id;
  const group_id = props.app.group_id;

  const customerInfo = props.cncService.customerInfoList[customer_id];
  const machineList = props.cncService.utilizationMachineList[customer_id];
  const shiftsFromRedux = props.cncService.utilizationShifts?.[customer_id];
  const shifts = shiftsFromRedux != null && Array.isArray(shiftsFromRedux)
    ? shiftsFromRedux
    : ["00:00-24:00", "", "", ""];

  var isPageLoading = machineList === undefined;

  const [selectedMachine, setSelectedmachine] = useState("");
  const [operatorList, setOperatorList] = useState([]);
  const [viewMode, setViewMode] = useState(0);
  const [shift, setShift] = useState(0);

  const [tick, setTick] = useState(true);
  const [intervalId, setIntervalID] = useState(null);
  const skipNextTickRef = useRef(false);
  const hasSetInitialShiftRef = useRef(false);
  const { group_ids } = authData;

  const intervalTime = 60000;

  const timezone = customerInfo["timezone"];

  let startDate = GetCustomerCurrentTime(timezone);
  startDate =
    pad(startDate.getMonth() + 1) +
    "/" +
    pad(startDate.getDate()) +
    "/" +
    pad(startDate.getFullYear());


  let endDate = GetCustomerCurrentTime(timezone);
  endDate.setDate(endDate.getDate() + 1);
  endDate =
    pad(endDate.getMonth() + 1) +
    "/" +
    pad(endDate.getDate()) +
    "/" +
    pad(endDate.getFullYear());

  useEffect(() => {
    GetStatus(customer_id, props.dispatch);
  }, [customer_id]);

  const onSetAutoScroll = (val) => {
    UpdateAppConfig({ isAutoScroll: val }, props.dispatch);
  };

  const timer = () => {
    setTick((t) => !t);
  };

  const onClickMachine = (machine) => {
    onSetAutoScroll(false);
    setSelectedmachine(machine);
  };

  // Auto-select machine from URL query parameter (for token-based URLs)
  useEffect(() => {
    if (!machineList || machineList.length === 0) return;
    
    const searchParams = new URLSearchParams(location.search);
    const machineIdFromUrl = searchParams.get("machine_id");
    
    if (machineIdFromUrl) {
      const machine = machineList.find((m) => m.machine_id === machineIdFromUrl);
      if (machine && selectedMachine === "") {
        setSelectedmachine(machine);
      }
    }
  }, [location.search, machineList, selectedMachine]);

  useEffect(() => {
    skipNextTickRef.current = true;
    setShift(0);
    hasSetInitialShiftRef.current = false;

    // Don't clear selectedMachine if it's from URL query param (for token-based URLs)
    const searchParams = new URLSearchParams(location.search);
    const machineIdFromUrl = searchParams.get("machine_id");

    if (!machineIdFromUrl) {
      setSelectedmachine("");
    }

    readOperatorList((res) => {
      setOperatorList(res);
      GetUtilizationData(
        customer_id,
        timezone,
        startDate,
        endDate,
        "",
        props.dispatch,
        "00:00-24:00"
      );
      const newIntervalId = setInterval(timer, intervalTime);
      setIntervalID(newIntervalId);
    });

    return () => {
      setIntervalID((currentId) => {
        if (currentId) clearInterval(currentId);
        return null;
      });
    };
  }, [customer_id]);

  // Refetch when user changes shift (only after initial load so we have shifts from API)
  useEffect(() => {
    if (machineList === undefined) return;
    const shiftTime = shifts[shift] != null && shifts[shift] !== "" ? shifts[shift] : "00:00-24:00";
    GetUtilizationData(
      customer_id,
      timezone,
      startDate,
      endDate,
      "",
      props.dispatch,
      shiftTime
    );
  }, [shift]);

  // Default to current shift once we have shifts from API (Utilization dashboard only)
  useEffect(() => {
    if (machineList === undefined || !shifts || shifts.length < 2) return;
    const hasAnyShift = (shifts[1] && shifts[1] !== "") || (shifts[2] && shifts[2] !== "") || (shifts[3] && shifts[3] !== "");
    if (!hasAnyShift || hasSetInitialShiftRef.current) return;
    hasSetInitialShiftRef.current = true;
    const factoryNow = GetCustomerCurrentTime(timezone);
    const currentShiftIndex = GetCurrentShiftIndex(shifts, factoryNow);
    if (currentShiftIndex >= 1) setShift(currentShiftIndex);
  }, [machineList, shifts, timezone]);

  useEffect(() => {
    // Skip only the first tick after mount/deps change (callback already fetched); then poll every interval.
    if (skipNextTickRef.current) {
      skipNextTickRef.current = false;
      return;
    }
    const shiftTime = shifts[shift] != null && shifts[shift] !== "" ? shifts[shift] : "00:00-24:00";
    GetUtilizationData(
      customer_id,
      timezone,
      startDate,
      endDate,
      "",
      props.dispatch,
      shiftTime
    );
  }, [tick, shift]);

  return (
    <div>
      {isPageLoading && (
        <div style={{ paddingTop: 100, textAlign: "center" }}>
          <Spin tip="Loading ..." size="large" />
        </div>
      )}
      {!isPageLoading && (
        <div>
          {selectedMachine == "" && (
            <div>
              <div className="list-tile-switch-container">
                <Select
                  className="page-changer-style"
                  style={{ width: 200, textAlign: "left", marginRight: 16 }}
                  dropdownClassName="page-changer-style-dropdown"
                  value={shift}
                  onChange={(e) => setShift(e)}
                >
                  <Option className="page-changer-item" key="shift-0" value={0}>
                    24 Hours
                  </Option>
                  <Option className="page-changer-item" key="shift-1" value={1}>
                    Shift 1 ({shifts.length > 1 ? shifts[1] : ""})
                  </Option>
                  <Option className="page-changer-item" key="shift-2" value={2}>
                    Shift 2 ({shifts.length > 2 ? shifts[2] : ""})
                  </Option>
                  <Option className="page-changer-item" key="shift-3" value={3}>
                    Shift 3 ({shifts.length > 3 ? shifts[3] : ""})
                  </Option>
                </Select>
                <Switch
                  className="list-tile-switch"
                  checked={viewMode == 1 ? true : false}
                  onChange={(e) => setViewMode(e == true ? 1 : 0)}
                />
                <div className="list-tile-switch-title">{"Tile"}</div>
              </div>
              <MachineItemContainer
                machineList={machineList}
                customer_id={customer_id}
                group_id={group_id}
                group_ids={group_ids}
                customerInfo={customerInfo}
                onClickMachine={onClickMachine}
                viewMode={viewMode}
                operatorList={operatorList}
                screenSize={screenSize}
                shift={shift}
                shifts={shifts}
                setShift={setShift}
                hideShiftDropdown
              />
            </div>
          )}

          <CSSTransition
            in={selectedMachine !== ""}
            timeout={1000}
            classNames="pageSliderLeft"
            unmountOnExit={true}
          >
            <UtilizationDetailPage
              customer_id={customer_id}
              customerInfo={customerInfo}
              machineInfo={selectedMachine}
              security_level={security_level}
              onCloseMachine={setSelectedmachine}
              operatorList={operatorList}
              screenSize={screenSize}
              dismissible
            />
          </CSSTransition>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, props) => ({
  cncService: state.cncService,
  app: state.app,
});

const mapDispatchToProps = (dispatch, props) => ({
  dispatch: dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(UtilizationDashboardPage);
